import {
    CREATE_SALES_RETURN,
    DELETE_SALES_RETURN,
    GET_SALES_RETURNS,
    GET_SALES_RETURNS_PAGE,
    SALES_RETURN_REQUEST,
    SALES_RETURN_REQUEST_SUCCESS,
    SALES_RETURN_REQUEST_FAILURE,
    UPDATE_SALES_RETURN,
    SET_BILL_ORDERS
  } from "../types";
  
  const initialState = {
    salesReturns: [],
    salesReturnsPage: [],
    billOrders: [],
    page: 1,
    pageSize: 10,
    search: '',
    where: {},
    total: 0,
    loading: false,
    error: null,
  };
  
  const salesReturnReducer = (state = initialState, action) => {
    switch (action.type) {
      case SALES_RETURN_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_SALES_RETURNS: {
        return {
          ...state,
          salesReturns: [...action.payload],
          loading: false,
          error: null
        }
      }
      case GET_SALES_RETURNS_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
          ...state,
          salesReturnsPage: [...data],
          total,
          page,
          pageSize,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
      }
      case CREATE_SALES_RETURN: {
        return {
          ...state,
          salesReturns: [action.payload, ...state.salesReturns],
          loading: false,
          error: null
        };
      }
      case UPDATE_SALES_RETURN: {
        const salesReturnsData = state.salesReturns.slice(0);
        const uIndex = salesReturnsData.findIndex((data) => data.id === action.payload.id);
        salesReturnsData.splice(uIndex, 1, { ...action.payload.data });
        return {
          ...state,
          salesReturns: [ ...salesReturnsData ],
          loading: false,
          error: null
        };
      }
      case DELETE_SALES_RETURN: {
        const salesReturns = state.salesReturns?.slice(0);
        const index = salesReturns.findIndex((data) => data.id === action.id);
        if (index > -1) {
          salesReturns.splice(index, 1);
        }
        return {
          ...state,
          salesReturns: [...salesReturns],
          loading: false,
          error: null
        }
      }
      case SALES_RETURN_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
      case SALES_RETURN_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      case SET_BILL_ORDERS: {
        return {
          ...state,
          billOrders: [...action.payload],
          loading: false,
          error: null
        }
      }
      default:
        return state;
    }
  };
  
  export default salesReturnReducer;
  